import { AfterViewInit, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { Subject } from 'rxjs';
import { delay } from 'rxjs/operators';

@Component({
    selector: 'app-progress-indicator',
    templateUrl: './progress-indicator.component.html',
    styleUrls: ['./progress-indicator.component.scss'],
})
export class ProgressIndicatorComponent implements AfterViewInit {
    private percantageValue: number;
    private progressRef: ElementRef;
    private progressTextSubject = new Subject<string>();
    public progressText$ = this.progressTextSubject.asObservable().pipe(delay(250));
    @Input() title: string;
    @Input() set percentage(value: number) {
        if (value != null) {
            this.percantageValue = value;
            if (this.progressRef) {
                this.setProgress(value);
            }
        }
    }

    constructor(
        private renderer: Renderer2,
        private elRef: ElementRef,
    ) {}

    ngAfterViewInit() {
        this.progressRef = this.elRef.nativeElement.querySelector('.progress-bar');
        this.setProgress(this.percantageValue);
    }

    private setProgress(progress: number): void {
        if (this.progressRef && progress >= 0 && progress <= 100) {
            this.renderer.setStyle(this.progressRef, 'width', progress + '%');
            this.progressTextSubject.next(`${Math.ceil(progress).toFixed(0)}%`);
        }
    }
}
